///<reference path="../../../../build/typings/index.d.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/decorators.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/providers/settings.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/configs/Global.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/configs/Http.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/directives/tab.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/directives/carousel.ts" />

///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/dashboard/providers/repository.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/dashboard/components/activation.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/dashboard/components/my-account.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/dashboard/components/announcement.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/dashboard/components/credits.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/dashboard/components/get-started.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/dashboard/components/review.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/dashboard/components/links.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/dashboard/components/subscribe.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/dashboard/components/support.ts" />
///<reference path="../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/dashboard/components/translate.ts" />
///<reference path="providers/repository.ts"/>
///<reference path="components/overview.ts"/>
///<reference path="components/blog-feed.ts"/>
///<reference path="components/feedback-collector.ts"/>

module TotalPoll {
    import GlobalConfig = TotalCore.Common.Configs.GlobalConfig;
    import HttpConfig = TotalCore.Common.Configs.HttpConfig;

    export const dashboard = angular
        .module('dashboard', [
            'ngResource',
            'services.common',
            'directives.common',
            'services.dashboard',
            'components.dashboard',
            'services.totalpoll',
            'components.totalpoll',
        ])
        .config(GlobalConfig)
        .config(HttpConfig)
        .value('ajaxEndpoint', window['ajaxurl'] || '/wp-admin/admin-ajax.php')
        .value('namespace', 'TotalPoll')
        .value('prefix', 'totalpoll')
}
